import React,{useRef} from 'react';
import {StaticImage} from "gatsby-plugin-image"
export default function FollowUpDesign(){
    const sectionRef = useRef();

    return (
        <section className="follow_up_design_section" ref={sectionRef}>
                <StaticImage  placeholder="blurred" loading="eager" quality={100} src="../../images/pages/about/bgg.png"  aspectRatio={0.3} className="follow_up_design_bg_sm_md" ></StaticImage>
                <StaticImage  placeholder="blurred" loading="eager"  quality={100} src="../../images/pages/about/bgg.png" layout="constrained" aspectRatio={16/9} className="follow_up_design_bg_lg" ></StaticImage>
            <div className="follow_up_design_container">
                <div className="follow_up_design_container__heading">
                    <h3>We designed an innovative way to help you track your progress and continue to maintain optimal health. </h3>
                </div>
                <div className="follow_up_design_container__precision_health" style={{"display":"flex"}}>
                    <div className="step_bullet"><p className="step_bullet__number">1</p></div>
                    <div>
                        <h3>Provide us with a new stool sample</h3>
                        <p>We integrate your current gut status with your DNA profile that was analyzed during the initial test.</p>
                    </div>
                </div>
                <div className="follow_up_design_container__dual_analysis" style={{"display":"flex"}}>
                    <div className="step_bullet"><p className="step_bullet__number">2</p></div>
                    <div>
                        <h3>Receive updated reports</h3>
                        <p>We will provide integrated reports with diet & lifestyle recommendations matched to your current gut status.</p>
                    </div>
                </div>
                {/* <div className="follow_up_design_container__image" >
                    <div ref={atomRef} className="follow_up_design_container__image__wrapper">
                        <StaticImage  placeholder="blurred" loading="eager"  quality={100} src="../../images/pages/about/atom.png" layout="constrained" className="follow_up_design_container__image__atom"  ></StaticImage>
                    </div>
                    <StaticImage  placeholder="blurred" loading="eager"  quality={100} src="../../images/pages/about/upright-leaf.svg" layout="constrained" className="follow_up_design_container__image__leaf" ></StaticImage>
                </div> */}
            </div>
        </section>
    );
}